import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useMemo } from "react";

/** Auth broadcast channel definition */
export const AuthBroadcastChannel = {
  name: "sphereDashboardAuth",
  messages: {
    logoutMessage: "sphere-dashboard-logout"
  }
};
/** Custom hook that handles an auth BroadcastChannel to share messages between browser tabs */
export function useAuthBroadcastChannel(t0) {
  const $ = _c(6);
  const {
    logoutCallback
  } = t0;
  let t1;
  bb0: {
    if (typeof BroadcastChannel === "undefined") {
      t1 = undefined;
      break bb0;
    }
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = new BroadcastChannel(AuthBroadcastChannel.name);
      $[0] = t2;
    } else {
      t2 = $[0];
    }
    t1 = t2;
  }
  const broadcastChannel = t1;
  let t2;
  if ($[1] !== logoutCallback) {
    t2 = () => {
      logoutCallback();
    };
    $[1] = logoutCallback;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const memoizedLogoutCallback = t2;
  let t3;
  let t4;
  if ($[3] !== memoizedLogoutCallback) {
    t3 = () => {
      if (!broadcastChannel) {
        return;
      }
      const onBroadcastChannelMessage = function onBroadcastChannelMessage(message) {
        if (message.data === AuthBroadcastChannel.messages.logoutMessage) {
          memoizedLogoutCallback();
        }
      };
      broadcastChannel.addEventListener("message", onBroadcastChannelMessage);
      return () => broadcastChannel.removeEventListener("message", onBroadcastChannelMessage);
    };
    t4 = [broadcastChannel, memoizedLogoutCallback];
    $[3] = memoizedLogoutCallback;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  return broadcastChannel;
}